import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NotificationBar from "@components/NotificationBarAudit/index";
import "../Uploaded-Details/uploaded-details.scss";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import qs from "query-string";
import { getValue } from "@utils/lodash";
import { toast } from "react-toastify";
import moment from "moment";
import {
  adminGetAllAuditList,
  adminGetAuditDashboardInfo,
  adminGetAuditList,
  adminUpdateAudit,
  getManageAuditScoreFilter,
  getVendorFilterLegislation,
  getVendorFilterLocation,
  vendorAuditChecklist,
} from "@services/audit.service";
import { NavLink } from "react-router-dom";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import {
  concatDotToDocumentString,
  concatDotToString,
  formatText,
} from "@_common/text-helpers";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import UploadModal from "./Modal/upload";
import CommentsModal from "./Modal/comments";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { clientDeleteSubmitCheckpointLocation } from "@services/auth.service";
import NoAccessPage from "@components/common/NoAccess";
import ReactTooltip from "react-tooltip";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { commentsTitleList, commentsValueList } from "@_common/comments";
import SearchHeader from "@components/common/SearchHeader";
import Search from "@components/common/Search";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import "./table.scss";
import MenuAuditSvgComponent from "../../../../assets/svg-components/left-menu/menuadit";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { formatDate } from "@_common/format-date";
import { convertCurrentDate } from "@_common/date-helpers";
import { sanitizeInput } from "@_common/dompurify";

export default function UploadedDetails(props: any) {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [request, setRequest] = useState<any>({
    remittance_date: new Date(),
    expiry_date: new Date(),
    audit_status: "",
  });

  const [remittance_date, setRemittance_date] = useState(null);
  const [expiry_date, setExpiry_date] = useState(null);
  const [dashboardInfo, setDashboardInfo] = useState({});
  const [dashboardLoading, setDashboardLoading] = useState(false);

  const [comments, setComments] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [update_status, setupdate_status] = useState("");

  const [filteredLocations, setFilteredLocations] = useState([]);
  const [filteredLegislation, setFilteredLegislation] = useState([]);
  const [filteredAccount, setFilteredAccount] = useState([]);
  const [comments1, setComments1] = useState("");
  const [recommendation, setRecommendation] = useState("");
  const [common_nc_group, setCommon_nc_group] = useState("");

  const [filters, setFilters] = useState({
    location: "",
    legislation: "",
    group: "",
  });

  const [carryForwardTask, setCarryForwardTask] = useState<boolean>(false);
  const [lifeTimeCarryForward, setLifeTimeCarryForward] =
    useState<boolean>(true);
  const [cc_expiry_date, setCC_Expiry_date] = useState(null);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      // getDashboardInfo();
      setDate(new Date());
      getFilterLocations("", "");
      getFilterLegislations("", "");
      getFilterAccount("", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getDashboardInfo();
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.d_page_no) {
        setPage_no(parseInt(params.d_page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      if (params.legislation_id || params.location_id || params.group_id) {
        setFilters({
          ...filters,
          legislation: getValue(params, `legislation_id`, ""),
          location: getValue(params, `location_id`, ""),
          group: getValue(params, `group_id`, ""),
        });
      }

      if (params.legislation_id) {
        getFilterLegislations(params.legislation_id, "");
      } else {
        getFilterLegislations("", "");
      }

      if (params.group_id) {
        getFilterAccount(params.group_id, "");
      } else {
        getFilterAccount("", "");
      }

      if (params.location_id) {
        getFilterLocations(params.location_id, "");
      } else {
        getFilterLocations("", "");
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [searchLoading1, setSearchLoading1] = useState(false);
  const getFilterLocations = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      location_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
      vendor_id: mainParams.id,
      month: params.date
        ? params.date.split("-")[1]
        : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
      type: "LOCATION",
      group_id: params.group_id,
    };
    let queryRequest = QueryRequestHelper(payload);
    setSearchLoading1(true);
    try {
      // let resp = await getVendorFilterLocation(queryRequest);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setFilteredLocations(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          })),
        );
        setSearchLoading1(false);
      } else {
        setSearchLoading1(false);
      }
    } catch (error) {
      setSearchLoading1(false);
    }
  };

  const getFilterLegislations = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      legislation_id: id,
      search_text: value,
      page_no: 1,
      page_size: 100,
      vendor_id: mainParams.id,
      location_id: params.location_id,
      group_id: params.group_id,
      month: params.date
        ? params.date.split("-")[1]
        : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
      type: "AUDIT_CHECKPOINT",
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getVendorFilterLegislation(queryRequest);
      // let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setFilteredLegislation(
          // getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            // id: getValue(item, `legislation_id`, ""),
            // value: getValue(item, `legislation_rule`, ""),
            // label: getValue(item, `legislation_rule`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          })),
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const getFilterAccount = async (id: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
      group_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
      type: "GROUP",
      vendor_id: mainParams.id,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setFilteredAccount(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            value: getValue(item, `group_name`, ""),
            label: getValue(item, `group_name`, ""),
          })),
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  const [complianceStatusList] = useState([
    { value: "NOT_SUBMITTED", label: "Not Submitted" },
    { value: "PENDING_AUDIT", label: "Pending Audit" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "SEND_BACK_TO_VENDOR", label: "Send Back to Vendor" },
  ]);
  const getDashboardInfo = async () => {
    let payload: any = {
      location_id: mainParams.id,
      month: mainParams.date ? parseInt(mainParams.date.split("-")[1]) : "",
      year: mainParams.date ? parseInt(mainParams.date.split("-")[0]) : "",
      vendor_id: "",
      // domain_name: getValue(localStorage, `client`, ""),
      type: "SUMMERY",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    try {
      setDashboardLoading(true);
      let resp = await adminGetAuditDashboardInfo(payload);
      if (resp) {
        setDashboardLoading(false);
        setDashboardInfo(getValue(resp, `data`, ""));
      } else {
        setDashboardLoading(false);
      }
    } catch (error) {
      setDashboardLoading(false);
    }
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      page_no: params.d_page_no ? parseInt(params.d_page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      // page_size: 10,
      search_text: params.search_text,
      status: params.status,

      location_id: params.location_id,
      // legislation_rule_id: params.legislation_id,
      legislation_id: params.legislation_id,
      sort_by: params.sort_by,
      upload_status: params.update_status,
      vendor_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      audit_status: params.audit_status,
      group_id: params.group_id,
      is_active: true,
      // domain_name: getValue(localStorage, `client`, ""),
      // audit_type:
      //   mainParams.route === "uploaded"
      //     ? "UPLOADED"
      //     : mainParams.route === "not-uploaded"
      //     ? "NOT_UPLOADED"
      //     : "COMPLETED",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await vendorAuditChecklist(queryRequest);
      console.log("222222222222222222222222ssssssssssssssssss", resp);
      if (resp) {
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        console.log("fffffffffffffffffffff2222222222", resp);
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataRefetch = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      page_no: params.d_page_no ? parseInt(params.d_page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by,
      upload_status: params.update_status,
      vendor_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      audit_status: params.audit_status,
      location_id: params.location_id,
      legislation_rule_id: params.legislation_id,
      group_id: params.group_id,
      is_active: true,

      // domain_name: getValue(localStorage, `client`, ""),
      // audit_type:
      //   mainParams.route === "uploaded"
      //     ? "UPLOADED"
      //     : mainParams.route === "not-uploaded"
      //     ? "NOT_UPLOADED"
      //     : "COMPLETED",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await vendorAuditChecklist(queryRequest);
      if (resp) {
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        console.log("fffffffffffffffffffff11111111111", resp);
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleDeleteFile = async (documentId: string, id: string) => {
    try {
      let resp = await clientDeleteSubmitCheckpointLocation(
        documentId,
        id,
        // getValue(localStorage, `client`, "")
      );
      if (resp) {
        toast.success("Deleted successfully");
        getDataRefetch();
      }
    } catch (error) {}
  };

  // const handleSubmitTask = async () => {
  //   try {
  //     let date1 = JSON.parse(JSON.stringify(remittance_date));
  //     let date2 = JSON.parse(JSON.stringify(expiry_date));
  //     let carry_forward_expiry_date = JSON.parse(
  //       JSON.stringify(cc_expiry_date)
  //     );
  //     if (comments) {
  //       setSubmitLoading(true);
  //       let payload: any = {
  //         ids: selectedIndex,
  //         audit_status: update_status,
  //         commentsInfo: {
  //           comments: comments,
  //           type:
  //             update_status === "SEND_BACK_TO_VENDOR"
  //               ? "REJECT_COMMENT"
  //               : "ACCEPTANCE_COMMENT",
  //         },
  //         // domain_name: getValue(localStorage, `client`, ""),
  //         remittance_date: date1 ? moment(date1).format("YYYY-MM-DD") : "",
  //         expiry_date: date2 ? moment(date2).format("YYYY-MM-DD") : "",
  //         recommendation: recommendation,
  //         common_nc_group: selectedCommentLabel
  //           ? selectedCommentLabel + ` - ` + selectedCommentValue
  //           : "",
  //         carry_forward_task: carryForwardTask,
  //         life_time_carry_forward: lifeTimeCarryForward,
  //         // carry_forward_expiry_date : carry_forward_expiry_date ? moment(carry_forward_expiry_date).format("YYYY-MM-DD") : "",
  //         carry_forward_expiry_date: lifeTimeCarryForward
  //           ? null
  //           : carry_forward_expiry_date
  //           ? moment(carry_forward_expiry_date).format("YYYY-MM-DD")
  //           : null,
  //       };
  //       // Object.keys(payload).forEach((key) => {
  //       //   if (!payload[key] || payload[key] === undefined) {
  //       //     delete payload[key];
  //       //   }
  //       // });
  //       Object.keys(payload).forEach((key) => {
  //         if (!payload[key] && key !== "carry_forward_expiry_date") {
  //           delete payload[key];
  //         }
  //       });

  //       let resp = await adminUpdateAudit(mainParams.id, payload);
  //       if (resp) {
  //         setSubmitLoading(false);
  //         toast.success("Submitted successfully");
  //         handleModal2();
  //         setComments("");
  //         getDataRefetch();
  //         setSelectedIndex([]);
  //         setRemittance_date(null);
  //         setExpiry_date(null);
  //         setSelectedCommentLabel("");
  //         setSelectedCommentValue("");
  //         setCC_Expiry_date(null);
  //         setCarryForwardTask(false);
  //         setLifeTimeCarryForward(false);
  //         setRecommendation("");
  //         getData();
  //       }
  //     } else {
  //       toast.error("Please add comments");
  //       setSubmitLoading(false);
  //     }
  //   } catch (error) {
  //     setSubmitLoading(false);
  //   }
  // };

  const handleSubmitTask = async () => {
    try {
      let date1 = JSON.parse(JSON.stringify(remittance_date));
      let date2 = JSON.parse(JSON.stringify(expiry_date));
      let carry_forward_expiry_date = JSON.parse(
        JSON.stringify(cc_expiry_date),
      );

      // Check if cc_expiry_date is mandatory and not provided
      if (!lifeTimeCarryForward && !cc_expiry_date) {
        toast.error("Please Add Expiry Date");
        return;
      }

      if (comments) {
        setSubmitLoading(true);
        let payload: any = {
          ids: selectedIndex,
          audit_status: update_status,
          commentsInfo: {
            comments: comments,
            type:
              update_status === "SEND_BACK_TO_VENDOR"
                ? "REJECT_COMMENT"
                : "ACCEPTANCE_COMMENT",
            audit_cycle: selectedReleaseCycleIds[0] || "",
          },
          remittance_date: date1 ? moment(date1).format("YYYY-MM-DD") : "",
          expiry_date: date2 ? moment(date2).format("YYYY-MM-DD") : "",
          recommendation: recommendation,
          // common_nc_group: selectedCommentLabel
          //   ? selectedCommentLabel + ` - ` + selectedCommentValue
          //   : "",
          carry_forward_task: carryForwardTask,
          life_time_carry_forward: lifeTimeCarryForward,
          carry_forward_expiry_date: lifeTimeCarryForward
            ? null
            : carry_forward_expiry_date
              ? moment(carry_forward_expiry_date).format("YYYY-MM-DD")
              : null,
          ...(update_status === "NON_COMPLIED" && {
            auto_marked_non_complied: false,
          }),
        };

        Object.keys(payload).forEach((key) => {
          if (
            !payload[key] &&
            key !== "carry_forward_expiry_date" &&
            key !== "life_time_carry_forward" &&
            key !== "auto_marked_non_complied"
          ) {
            delete payload[key];
          }
        });

        console.log(payload, "===Payload==>");
        let resp = await adminUpdateAudit(mainParams.id, payload);
        if (resp) {
          setSubmitLoading(false);
          toast.success("Submitted successfully");
          handleModal2();
          setComments("");
          getDataRefetch();
          setSelectedIndex([]);
          setRemittance_date(null);
          setExpiry_date(null);
          setSelectedCommentLabel("");
          setSelectedCommentValue("");
          setCC_Expiry_date(null);
          setCarryForwardTask(false);
          setLifeTimeCarryForward(true);
          setRecommendation("");
          getData();
          setSelectedReleaseCycleIds([]);
        }
      } else {
        toast.error("Please add comments");
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
      console.error("Error submitting task:", error);
    }
  };

  const handleUpdateStatus = async (update_status: string) => {
    setupdate_status(update_status);
    handleModal2();
  };
  const handleUpdateStatus1 = async (update_status: string) => {
    let list = locations.filter(
      (item: any) => item.id === getValue(selectedIndex, `[${0}]`, ""),
    );
    setRequest({
      ...request,
      remittance_date: getValue(list, `[${0}].remittance_date`, "")
        ? new Date(getValue(list, `[${0}].remittance_date`, ""))
        : null,
      expiry_date: getValue(list, `[${0}].expiry_date`, "")
        ? new Date(getValue(list, `[${0}].expiry_date`, ""))
        : null,
      audit_status: getValue(list, `[${0}].audit_status`, ""),
    });
    setupdate_status(update_status);
    handleModal3();
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [isOpen1, setIsOpen1] = useState(false);
  const handleModal1 = () => {
    setIsOpen1(!isOpen1);
  };

  const [isOpen2, setIsOpen2] = useState(false);
  const handleModal2 = () => {
    setIsOpen2(!isOpen2);
  };

  const [isOpen4, setIsOpen4] = useState(false);
  const handleModal4 = () => {
    setIsOpen4(!isOpen4);
  };

  const [vendorInfo, setVendorInfo] = useState({});
  const handleModalComment = (obj: object) => {
    setVendorInfo(obj);
    handleModal();
  };
  const handleModalCommentCancel = () => {
    setVendorInfo({});
    handleModal();
  };

  const handleModalUpload = (obj: object) => {
    setVendorInfo(obj);
    handleModal1();
  };
  const handleModalUploadCancel = () => {
    setVendorInfo({});
    handleModal1();
  };

  const [isOpen3, setIsOpen3] = useState(false);
  const handleModal3 = () => {
    setIsOpen3(!isOpen3);
  };

  const handleUpdateStatusSpecific = async (
    update_status: string,
    id: String,
  ) => {
    let uniq =
      getValue(selectedIndex, `length`, 0) > 0
        ? selectedIndex.filter((item: string) => item === id)
        : [];
    if (uniq.length === 0) {
      selectedIndex.push(id);
    }
    setupdate_status(update_status);
    handleModal2();
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [d_page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.d_page_no = page_no;
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      d_page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      d_page_no: 1,
      search_text: e.target.value,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                                 */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    let payload: any = {
      date: dates,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Checkbox Section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIndex, setSelectedIndex] = useState<any>([]);
  const [selectedReleaseCycleIds, setSelectedReleaseCycleIds] = useState<
    string[]
  >([]);

  // const handleChangeCheckbox = (id: String) => {
  //   // if (mainParams.route !== "not-uploaded") {
  //   // if (mainParams.route === "completed") {
  //   // 	let selected = selectedIndex.filter((item: string) => item === id);
  //   // 	if (getValue(selected, `length`, 0) !== 0) {
  //   // 		setSelectedIndex([]);
  //   // 	} else {
  //   // 		setSelectedIndex([id]);
  //   // 	}
  //   // } else {
  //   let selected = selectedIndex.filter((item: string) => item === id);
  //   if (getValue(selected, `length`, 0) === 0) {
  //     selectedIndex.push(id);
  //     setSelectedIndex([...selectedIndex]);
  //   } else {
  //     let selected = selectedIndex.filter((item: string) => item !== id);
  //     setSelectedIndex(selected);
  //   }
  //   // 	}
  //   // }
  // };

  const handleChangeCheckbox = (
    id: string,
    releaseCycleId: string | undefined,
  ) => {
    setSelectedIndex((prev: any) => {
      const isSelected = prev.includes(id);
      if (isSelected) {
        // Remove id and corresponding releaseCycleId when unchecked
        setSelectedReleaseCycleIds((prevIds) =>
          prevIds.filter((cycleId) => cycleId !== releaseCycleId),
        );
        return prev.filter((item: any) => item !== id);
      } else {
        // Add id and corresponding releaseCycleId when checked
        if (releaseCycleId) {
          setSelectedReleaseCycleIds((prevIds) => [...prevIds, releaseCycleId]);
        }
        return [...prev, id];
      }
    });
  };

  const [all, setAll] = useState("false");
  const handleChangeAllLocations = (value: string) => {
    setAll(value);
    if (value === "true") {
      let loc = locations.map((item: object) => getValue(item, `id`, ""));
      setSelectedIndex(loc);
    } else {
      setSelectedIndex([]);
    }
  };

  const handleRemoveNavItems = () => {
    handleChangeAllLocations("false");
  };

  const [filterOptions] = useState([
    { value: "COMPLIED", label: "Complied" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "SEND_BACK_TO_VENDOR", label: "Reject Back to Vendor" },
  ]);
  const [filterOptions1] = useState([
    { value: "Update", label: "Update Remittance And Expiry Date" },
  ]);

  const [selectedCommentLabel, setSelectedCommentLabel] = useState<any>("");
  const [selectedCommentValue, setSelectedCommentValue] = useState<any>("");
  const handleChangeComments = (type: string, value: string) => {
    if (type === "label") {
      setSelectedCommentLabel(value);
      setComments(`${value} - ${selectedCommentValue}`);
    } else {
      setSelectedCommentValue(value);
      setComments(`${selectedCommentLabel} - ${value}`);
    }
  };
  const handleChangeComments1 = (type: string, value: string) => {
    if (type === "label") {
      setSelectedCommentLabel(value);
      setComments1(`${value} - ${selectedCommentValue}`);
    } else {
      setSelectedCommentValue(value);
      setComments1(`${selectedCommentLabel} - ${value}`);
    }
  };

  const [submitRequestLoading, setSubmitRequestLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      setSubmitRequestLoading(true);
      let obj = JSON.parse(JSON.stringify(request));
      let payload = {
        ids: selectedIndex,
        remittance_date: getValue(obj, `remittance_date`, "")
          ? moment(getValue(obj, `remittance_date`, "")).format("YYYY-MM-DD")
          : null,
        expiry_date: getValue(obj, `expiry_date`, "")
          ? moment(getValue(obj, `expiry_date`, "")).format("YYYY-MM-DD")
          : null,
        audit_status: getValue(obj, `audit_status`, ""),
        commentsInfo: {
          comments: "Updated Remittance / Expiry Date",
          type: "SUBMISSION_COMMENT",
          audit_cycle: selectedReleaseCycleIds[0] || "",
        },
        ...(update_status === "NON_COMPLIED" && {
          auto_marked_non_complied: false,
        }),
      };

      let resp = await adminUpdateAudit(mainParams.id, payload);
      if (resp) {
        setSubmitRequestLoading(false);
        handleModal3();
        toast.success(getValue(resp, `message`, ""));
        getData();
        setSelectedReleaseCycleIds([]);
      } else {
        setSubmitRequestLoading(false);
      }
    } catch (error) {
      setSubmitRequestLoading(false);
    }
  };

  const handleChangeUpdate = async () => {
    if (comments1 && updateValue) {
      try {
        setSubmitRequestLoading(true);
        let payload = {
          ids: selectedIndex,
          audit_status: updateValue,
          commentsInfo: {
            comments: comments1,
            type: "SUBMISSION_COMMENT",
            audit_cycle: selectedReleaseCycleIds[0] || "",
          },
          ...(update_status === "NON_COMPLIED" && {
            auto_marked_non_complied: false,
          }),
        };
        let resp = await adminUpdateAudit(mainParams.id, payload);
        if (resp) {
          setSubmitRequestLoading(false);
          handleModal4();
          toast.success(getValue(resp, `message`, ""));
          setUpdateValue("");
          setComments1("");
          getData();
          setSelectedReleaseCycleIds([]);
          setSelectedIndex([]);
        } else {
          setSubmitRequestLoading(false);
          setSelectedIndex([]);
        }
      } catch (error) {
        setSubmitRequestLoading(false);
      }
    } else {
      toast.error("Comments / Status fields are mandatory");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Static Section                             */
  /* -------------------------------------------------------------------------- */

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let enableCopy: any =
    getValue(selectedIndex, `length`, 0) === 1
      ? getValue(locations, `length`, 0) > 0 &&
        locations.filter(
          (item: object) =>
            getValue(item, `id`, "") === getValue(selectedIndex, `[${0}]`, ""),
        )
      : [];

  const handleChangeFilter = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        d_page_no: 1,
      };
      setFilters({
        ...filters,
        [name]: value,
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        d_page_no: 1,
      };
      setFilters({
        ...filters,
        [name]: "",
      });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  const [updateValue, setUpdateValue] = useState("");

  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */
  const [searchLoading, setSearchLoading] = useState(false);

  const handleTriggerLocation = async (value: string) => {
    if (!value) {
      setFilters({
        ...filters,
        location: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.location_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilters({
        ...filters,
        location: value,
      });
      getFilterLocations("", value);
    }
  };
  const handleTriggerLegislation = async (value: string) => {
    if (!value) {
      setFilters({
        ...filters,
        legislation: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.legislation_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilters({
        ...filters,
        legislation: value,
      });
      getFilterLegislations("", value);
    }
  };

  const handleTriggerAccount = async (value: string) => {
    if (!value) {
      setFilters({
        ...filters,
        group: "",
      });
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.group_id;
      let payload = {
        ...params,
        d_page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      setFilters({
        ...filters,
        group: value,
      });
      getFilterAccount("", value);
    }
  };

  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = useMemo(
    () => urlParamsFun(),
    [window.location.href],
  );
  const handleNavigateFilter = (type: string) => {
    let payload: any = {
      ...params,
      d_page_no: 1,
      audit_status: type,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  // const [groupsList, setGroupsList] = useState([]);
  // const [groupLoading, setGroupLoading] = useState(false);
  // const getGroupsList = async (
  //   search_text: string,
  //   region_id: string,
  //   id: string
  // ) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   try {
  //     let payload = {
  //       month: params.date
  //         ? params.date.split("-")[1]
  //         : date
  //         ? moment(date).format("MM")
  //         : moment(dates).format("MM"),
  //       year: params.date
  //         ? params.date.split("-")[0]
  //         : date
  //         ? moment(date).format("YYYY")
  //         : moment(dates).format("YYYY"),
  //       region_id: region_id,
  //       type: "GROUP",
  //       search_text: search_text,
  //       group_id: id,
  //       page_size:  100,
  //     };
  //     setGroupLoading(true);
  //     let queryRequest = QueryRequestHelper(payload);
  //     let resp = await getManageAuditScoreFilter(queryRequest);
  //     if (resp) {
  //       setGroupsList(
  //         getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
  //           ...item,
  //           id: getValue(item, `group_id`, ""),
  //           label: getValue(item, `group_name`, ""),
  //           value: getValue(item, `group_name`, ""),
  //         }))
  //       );
  //       setGroupLoading(false);
  //     } else {
  //       setGroupLoading(false);
  //     }
  //   } catch (error) {
  //     setGroupLoading(false);
  //   }
  // };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "audit_vendor_audit",
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {
            // getValue(props, `permissions`, []).includes("update") &&
            // mainParams.route !== "not-uploaded" &&
            getValue(selectedIndex, `length`, 0) > 0 && (
              <NotificationBar
                isFilterVisisbile={
                  // getValue(selectedIndex, `length`, 0) === 1 ||
                  // mainParams.route === "uploaded"
                  true
                }
                selectedIDs={selectedIndex}
                handleRemoveNavItems={handleRemoveNavItems}
                filterOptions={
                  // mainParams.route === "uploaded"
                  //   ? filterOptions
                  //   : filterOptions1
                  filterOptions
                }
                handleUpdateStatus={
                  // mainParams.route === "uploaded"
                  //   ? handleUpdateStatus
                  //   : handleUpdateStatus1
                  handleUpdateStatus
                }
                permissions={props.permissions}
                // updateStatus={mainParams.route === "completed" ? true : false}
                updateStatus={true}
                handleChangeUpdate={handleModal4}
              />
            )
          }
          <div className="dashboard-wrapper__header d-flex mb-1 justify-content-between align-items-center d-none">
            <div className="d-flex">
              <NavLink
                // to={`/audit/vendor/${mainParams.route}?date=${mainParams.date}`}
                to={`/audit/vendor-audit?${mainQueryRequest}`}
                className="mt-1"
              >
                <img src="/images/back-link.svg" className="img-fluid" />
              </NavLink>
              &nbsp;&nbsp;&nbsp;
              <h6 className="mt-1">
                {getValue(mainParams, `name`, "")} -{" "}
                {moment(getValue(mainParams, `date`, "")).format("MMM, YYYY")}
              </h6>
            </div>
            {/* {mainParams.route === "uploaded" && ( */}
            <NavLink
              to={`/audit/details/headcount/${getValue(
                mainParams,
                `id`,
                "",
              )}/${getValue(mainParams, `date`, "")}/${getValue(
                mainParams,
                `route`,
                "",
              )}/${getValue(mainParams, `name`, "")}?${mainQueryRequest}`}
            >
              <div
                className="d-flex cursor-pointer"
                style={{ color: "#276ef1" }}
              >
                <img
                  src="/images/pending_actions_black.svg"
                  className="img-fluid"
                  style={{ color: "#276ef1" }}
                />
                &nbsp;
                <h6>Head Count</h6>
              </div>
            </NavLink>
            {/* )} */}
          </div>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                // to={`/audit/vendor/${mainParams.route}?date=${mainParams.date}`}
                // to={`/audit/vendor-audit?${mainQueryRequest}`}
                to={`/audit/vendor-audit?${mainQueryRequest}`}
                className="me-2"
              >
                <img src="/images/back-link.svg" className="img-fluid" />
              </NavLink>
              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Vendor Audit
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  <span>
                    {getValue(mainParams, `name`, "")} -{" "}
                    {moment(getValue(mainParams, `date`, "")).format(
                      "MMM, YYYY",
                    )}
                  </span>
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <NavLink
                to={`/audit/details/headcount/${getValue(
                  mainParams,
                  `id`,
                  "",
                )}/${getValue(mainParams, `date`, "")}/${getValue(
                  mainParams,
                  `route`,
                  "",
                )}/${getValue(mainParams, `name`, "")}?${mainQueryRequest}`}
              >
                <div
                  className="d-flex cursor-pointer"
                  style={{ color: "#276ef1" }}
                >
                  <img
                    src="/images/pending_actions_black.svg"
                    className="img-fluid"
                    style={{ color: "#276ef1" }}
                  />
                  &nbsp;
                  <h6>Head Count</h6>
                </div>
              </NavLink>
              <RightMenuHeaders
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //Line Seperator of button
                lineSeperator={true}
              />
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper has-module-filter`}
            id={
              getValue(selectedIndex, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <section className="d-flex align-items-center justify-content-between mb-4">
              <div className="d-flex justify-content-between">
                <div className="filter-form-wrappper__location flex-1">
                  <div className="filter-form-wrappper__location-form-group form-group mb-0 d-flex module-filter-wrapper">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label
                        htmlFor="country_id"
                        className="floating-label ms-0"
                      >
                        Account
                      </label>

                      <FilterSearchDropdown
                        placeholder={"Search Account"}
                        options={filteredAccount}
                        searchLoading={searchLoading}
                        handleChange={
                          (val: any) => handleTriggerAccount(val)
                          // console.log(val, "===VAL===")
                        }
                        handleClick={(e: any) =>
                          handleChangeFilter("group_id", e.id)
                        }
                        value={
                          getValue(filteredAccount, `length`, 0) > 0 &&
                          filteredAccount.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(filters, `group`, ""),
                          )[0]
                        }
                        label="label"
                        id="id"
                        name="Group"
                      />
                    </div>

                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label
                        htmlFor="country_id"
                        className="floating-label ms-0"
                      >
                        Sites
                      </label>
                      {/* <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose Location"
                        className="form-control w-100"
                        name="location_id"
                        id="location_id"
                        options={filteredLocations}
                        value={
                          getValue(filteredLocations, `length`, 0) > 0 &&
                          filteredLocations.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(params, `location_id`, "")
                          )
                        }
                        onChange={(e: any) =>
                          handleChangeFilter("location_id", getValue(e, `id`, ""))
                        }
                        label="Country"
                        isClear
                      /> */}

                      <FilterSearchDropdown
                        placeholder={"Search Site"}
                        options={filteredLocations}
                        searchLoading={searchLoading1}
                        handleChange={(val: any) => handleTriggerLocation(val)}
                        handleClick={(e: any) =>
                          handleChangeFilter("location_id", e.id)
                        }
                        value={
                          getValue(filteredLocations, `length`, 0) > 0 &&
                          filteredLocations.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(filters, `location`, ""),
                          )[0]
                        }
                        label="label"
                        id="id"
                        name="Location"
                      />
                    </div>
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label
                        htmlFor="country_id"
                        className="floating-label ms-0"
                      >
                        Legislation
                      </label>
                      <FilterSearchDropdown
                        placeholder={"Search Legislation"}
                        options={filteredLegislation}
                        searchLoading={searchLoading}
                        handleChange={(val: any) =>
                          handleTriggerLegislation(val)
                        }
                        handleClick={(e: any) =>
                          handleChangeFilter("legislation_id", e.id)
                        }
                        value={
                          getValue(filteredLegislation, `length`, 0) > 0 &&
                          filteredLegislation.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(filters, `legislation`, ""),
                          )[0]
                        }
                        label="label"
                        id="id"
                        name="Legislation"
                      />
                    </div>
                    <div>
                      <div className="module_filter_fields_wrapper">
                        <label
                          htmlFor="country_id"
                          className="floating-label ms-0"
                        >
                          Status
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT_MODAL"
                          placeholder="Choose Status"
                          className="form-control w-100"
                          options={complianceStatusList}
                          value={complianceStatusList.find(
                            (item: object) =>
                              getValue(params, `audit_status`, "") ===
                              getValue(item, `value`, ""),
                          )}
                          onChange={(e: any) =>
                            handleNavigateFilter(getValue(e, `value`, ""))
                          }
                          label="Country"
                          isClear
                          customClass="module_filter_dropdown_wrapper"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div>
                <Search
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                />
              </div> */}
            </section>
            <section className="table-uploaded-details-wrapper m-0 p-0 vendor-audit-page">
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : getValue(locations, `length`, 0) > 0 ? (
                <>
                  <div className="table-container">
                    <table className="uploaded-wrapper__table w-auto m-0">
                      <thead>
                        <th
                          style={{
                            minWidth: "50px",
                            maxWidth: "50px",
                            width: "50px",
                            textAlign: "center",
                          }}
                        >
                          <h5 className="header">
                            {/* Select All */}
                            {/* {mainParams.route !== "not-uploaded" && (
                              <label
                                className="m-0 position-relative"
                                htmlFor="header-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  className="default-checkbox"
                                  id="header-checkbox"
                                  onChange={() =>
                                    handleChangeAllLocations(
                                      all === "true" ? "false" : "true"
                                    )
                                  }
                                  checked={
                                    locations.length === selectedIndex.length &&
                                    all === "true"
                                  }
                                />
                                <div className="custom-checkbox">
                                  <img
                                    src="/images/uploaded-details/tick.svg"
                                    className="img-fluid uploaded-tick"
                                  />
                                </div>
                              </label>
                            )} */}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </h5>
                          <p className="subHeader"></p>
                        </th>
                        <th
                          style={{
                            minWidth: "100px",
                            maxWidth: "100px",
                            width: "100px",
                          }}
                        >
                          {/* <h5 className="header">Form name</h5> */}
                          {/* <p className="subHeader">Task ID</p> */}
                          <h5 className="header">Task ID</h5>
                        </th>
                        <th style={{ minWidth: "250px", width: "250px" }}>
                          {/* <h5 className="header">Legislation</h5> */}
                          <h5 className="header">Compliance Activity</h5>
                          <p className="subHeader">Legislation Rule</p>
                        </th>
                        <th style={{ minWidth: "100px", width: "100px" }}>
                          <h5 className="header">Account</h5>
                          {/* <p className="subHeader">Risk</p> */}
                        </th>
                        <th
                          style={{
                            minWidth: "100px",
                            maxWidth: "100px",
                            width: "100px",
                          }}
                        >
                          <h5 className="header">Site Name</h5>
                          <p className="subHeader">Audit Status</p>
                        </th>
                        <th
                          style={{
                            minWidth: "150px",
                            maxWidth: "150px",
                            width: "150px",
                          }}
                        >
                          <h5 className="header">Legislation</h5>
                        </th>
                        <th
                          style={{
                            minWidth: "140px",
                            maxWidth: "140px",
                            width: "140px",
                          }}
                        >
                          <h5 className="header">Comment</h5>
                          <p className="subHeader">Recommendation</p>
                        </th>
                        {/* <th style={{
                            minWidth: "100px",
                            maxWidth: "100px",
                            width: "100px",
                          }}>
                          <h5 className="header">Risk</h5>
                        </th> */}

                        {/* <th style={{
                            minWidth: "180px",
                            maxWidth: "180px",
                            width: "180px",
                          }}>
                          <h5 className="header">Carry Forward Task</h5>
                        </th> */}

                        <th
                          style={{
                            minWidth: "275px",
                            maxWidth: "275px",
                            width: "275px",
                          }}
                        >
                          <h5 className="header">Action</h5>
                          {/* <p className="subHeader">Action</p> */}
                        </th>
                      </thead>
                      <tbody>
                        {getValue(locations, `length`, 0) > 0 &&
                          locations.map((bodyObj: object, index: number) => {
                            const vendorCheckpointAuditCycles = getValue(
                              bodyObj,
                              "vendor_checkpoint_audit_cycles",
                              [],
                            );
                            const releaseCycleId =
                              vendorCheckpointAuditCycles.find((cycle: any) => {
                                const releaseDateAuditCycle = getValue(
                                  cycle,
                                  "release_date_audit_cycle",
                                  null,
                                );
                                return (
                                  releaseDateAuditCycle &&
                                  Object.keys(releaseDateAuditCycle).length > 0
                                );
                              })?.id;

                            const releaseAuditCycleId =
                              vendorCheckpointAuditCycles.find((cycle: any) => {
                                const releaseDateAuditCycle = getValue(
                                  cycle,
                                  "release_date_audit_cycle",
                                  null,
                                );
                                return (
                                  releaseDateAuditCycle &&
                                  Object.keys(releaseDateAuditCycle).length > 0
                                );
                              })?.release_date_audit_cycle?.id;

                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  <td
                                    style={{
                                      minWidth: "50px",
                                      maxWidth: "50px",
                                      width: "50px",
                                    }}
                                  >
                                    {/* {mainParams.route !== "not-uploaded" && ( */}
                                    {/* {(params.audit_status === "PENDING_AUDIT" ||
                                      getValue(bodyObj, `audit_status`, "") ===
                                        "PENDING_AUDIT") && ( */}
                                    {/* {getValue(
                                      bodyObj,
                                      `is_submitted`,
                                      false
                                    ) && ( */}
                                    <label
                                      className="m-0 position-relative"
                                      htmlFor={`details-${index}`}
                                    >
                                      <input
                                        type="checkbox"
                                        className="default-checkbox"
                                        id={`details-${index}`}
                                        checked={selectedIndex.includes(
                                          getValue(bodyObj, `id`, ""),
                                        )}
                                        onChange={() =>
                                          handleChangeCheckbox(
                                            getValue(bodyObj, `id`, ""),
                                            releaseAuditCycleId,
                                          )
                                        }
                                      />
                                      <div className="custom-checkbox">
                                        <img
                                          src="/images/uploaded-details/tick.svg"
                                          className="img-fluid uploaded-tick"
                                        />
                                      </div>
                                    </label>
                                    {/* )} */}
                                    {/* )} */}
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "100px",
                                      maxWidth: "100px",
                                      width: "100px",
                                    }}
                                  >
                                    <div className="body-container">
                                      <p className="title">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.form_no`,
                                          "",
                                        )}
                                      </p>
                                      {/* <p className="desc">
                                        {getValue(bodyObj, `task_id`, "")}
                                      </p> */}
                                      <p className="uploaded-details-wrapper__body-text mt-2">
                                        <span style={{ position: "relative" }}>
                                          {getValue(bodyObj, `task_id`, "")}
                                          <ReactTooltip id="count">
                                            <span>Submit Count</span>
                                          </ReactTooltip>
                                          {parseInt(
                                            getValue(
                                              bodyObj,
                                              `submit_count`,
                                              1,
                                            ),
                                          ) > 1 && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                height: "20px",
                                                width: "20px",
                                                borderRadius: "10px",
                                                backgroundColor: "#ff2d55",
                                                right: "-21px",
                                                top: "-6px",
                                              }}
                                              data-tip
                                              data-for="count"
                                            >
                                              <p
                                                style={{
                                                  color: "white",
                                                  textAlign: "center",
                                                  fontSize: "12px",
                                                  alignContent: "center",
                                                  marginTop: "2px",
                                                }}
                                              >
                                                {getValue(
                                                  bodyObj,
                                                  `submit_count`,
                                                  "",
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "250px",
                                      width: "250px",
                                    }}
                                  >
                                    <div className="body-container mw-100">
                                      {/* <p className="title">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.legislation.legislation_name`,
                                          ""
                                        )}
                                      </p> */}
                                      {/* <p className="title">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.compliance_activity`,
                                          ""
                                        )}
                                      </p> */}
                                      <p className="desc-text mb-1">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.compliance_activity`,
                                          "",
                                        )}
                                      </p>
                                      <p className="desc-text">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.legislation_rule.rule_name`,
                                          "",
                                        )}
                                      </p>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "100px",
                                      maxWidth: "100px",
                                      width: "100px",
                                    }}
                                  >
                                    <div className="body-container">
                                      <p
                                        className="desc-text"
                                        style={{ minWidth: "auto" }}
                                      >
                                        {getValue(
                                          bodyObj,
                                          `location.group.group_name`,
                                          "-",
                                        )}
                                      </p>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "100px",
                                      maxWidth: "100px",
                                      width: "100px",
                                    }}
                                  >
                                    <div className="body-container">
                                      <p
                                        className="title-green"
                                        data-tip
                                        data-for={`location${index}`}
                                      >
                                        {formatText(
                                          getValue(
                                            bodyObj,
                                            `location.location_name`,
                                            "",
                                          ),
                                        )}
                                      </p>
                                      <p className="desc-text">
                                        {formatText(
                                          getValue(bodyObj, `audit_status`, ""),
                                        )}
                                      </p>
                                    </div>
                                    <ReactTooltip id={`location${index}`}>
                                      <span>
                                        {getValue(
                                          bodyObj,
                                          `location.address1`,
                                          "",
                                        )}
                                        ,{" "}
                                        {getValue(
                                          bodyObj,
                                          `location.city.name`,
                                          "",
                                        )}
                                        ,{" "}
                                        {getValue(
                                          bodyObj,
                                          `location.pincode`,
                                          "",
                                        )}
                                      </span>
                                    </ReactTooltip>
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "150px",
                                      maxWidth: "150px",
                                      width: "150px",
                                    }}
                                  >
                                    <div className="body-container">
                                      {/* <p className="desc-text"> */}
                                      <small className="small-text">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.legislation.legislation_name`,
                                          "-",
                                        )}
                                      </small>
                                      {/* </p> */}
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      minWidth: "140px",
                                      maxWidth: "140px",
                                      width: "140px",
                                    }}
                                  >
                                    <div className="body-container">
                                      {/* <p className="desc-text" style={{minWidth: "180px"}}> */}
                                      <small className="small-text">
                                        {getValue(
                                          bodyObj,
                                          `recent_comment.comments`,
                                          "--",
                                        )}
                                      </small>{" "}
                                      <br />
                                      {/* </p>
                                      <p className="desc-text" style={{minWidth: "180px"}}> */}
                                      {getValue(bodyObj, "audit_status", "") !==
                                        "COMPLIED" &&
                                      getValue(bodyObj, "audit_status", "") !==
                                        "NOT_APPLICABLE" ? (
                                        <>
                                          {/* {getValue(bodyObj, 'audit_status', '')} */}
                                          <small className="small-text">
                                            {getValue(
                                              bodyObj,
                                              "recommendation",
                                              "--",
                                            )}
                                          </small>
                                        </>
                                      ) : (
                                        "-"
                                      )}
                                      {/* </p> */}
                                    </div>
                                  </td>
                                  {/* Risk */}
                                  {/* <td style={{
                                    minWidth: "100px",
                                    maxWidth: "100px",
                                    width: "100px",
                                  }}>
                                    <div className="body-container">
                                      <p className="title">
                                        {getValue(
                                          bodyObj,
                                          `checkpoint.impact_on_organization.text`,
                                          "-"
                                        )}
                                      </p>
                                    </div>
                                  </td> */}

                                  {/* Carry Forward Task */}
                                  {/* <td style={{
                                    minWidth: "180px",
                                    maxWidth: "180px",
                                    width: "180px",
                                  }}>
                                    <div className="body-container">
                                      <p className="desc-text">
                                      
                                      {getValue(bodyObj, "carry_forward_task", false) 
                                        ? <><strong>Active</strong> ({
                                            getValue(bodyObj, "life_time_carry_forward", false)
                                              ? "Life Time"
                                              : convertCurrentDate(getValue(bodyObj, "carry_forward_expiry_date", "")) || "No Expiry Date"
                                          })</>
                                        : (
                                          <strong> Inactive </strong>
                                        )}
                                      </p>
                                    </div>
                                  </td> */}
                                  <td
                                    style={{
                                      minWidth: "275px",
                                      maxWidth: "275px",
                                      width: "275px",
                                    }}
                                  >
                                    <div className="body-container">
                                      {/* {getValue(
                                        props,
                                        `permissions`,
                                        []
                                      ).includes("update") ? ( */}
                                      <div className="document-icons">
                                        {params.audit_status ===
                                          "PENDING_AUDIT" ||
                                        getValue(
                                          bodyObj,
                                          `audit_status`,
                                          "",
                                        ) === "PENDING_AUDIT" ? (
                                          <>
                                            <div
                                              data-tip
                                              data-for="happyFace"
                                              // className="uploaded-details-wrapper__icons-wrapper_image"
                                            >
                                              <img
                                                src="/images/uploaded-details/img4.svg"
                                                className="img-fluid cursor-pointer"
                                                height={36}
                                                width={36}
                                                onClick={() =>
                                                  getValue(
                                                    props,
                                                    `permissions`,
                                                    [],
                                                  ).includes("update") &&
                                                  handleUpdateStatusSpecific(
                                                    "NOT_APPLICABLE",
                                                    getValue(bodyObj, `id`, ""),
                                                  )
                                                }
                                              />
                                            </div>
                                            <div
                                              data-tip
                                              data-for="happyFace1"
                                              // className="uploaded-details-wrapper__icons-wrapper_image"
                                            >
                                              <img
                                                src="/images/uploaded-details/img3.svg"
                                                className="img-fluid cursor-pointer"
                                                height={36}
                                                width={36}
                                                onClick={() =>
                                                  getValue(
                                                    props,
                                                    `permissions`,
                                                    [],
                                                  ).includes("update") &&
                                                  handleUpdateStatusSpecific(
                                                    "COMPLIED",
                                                    getValue(bodyObj, `id`, ""),
                                                  )
                                                }
                                              />
                                            </div>
                                            <div
                                              data-tip
                                              data-for="happyFace2"
                                              // className="uploaded-details-wrapper__icons-wrapper_image"
                                            >
                                              <img
                                                src="/images/uploaded-details/img6.svg"
                                                className="img-fluid cursor-pointer"
                                                height={36}
                                                width={36}
                                                onClick={() =>
                                                  getValue(
                                                    props,
                                                    `permissions`,
                                                    [],
                                                  ).includes("update") &&
                                                  handleUpdateStatusSpecific(
                                                    "NON_COMPLIED",
                                                    getValue(bodyObj, `id`, ""),
                                                  )
                                                }
                                              />
                                            </div>
                                          </>
                                        ) : null}
                                        <div
                                          data-tip
                                          data-for="happyFace3"
                                          // className="uploaded-details-wrapper__icons-wrapper_image"
                                        >
                                          <img
                                            src="/images/uploaded-details/img1.svg"
                                            className="img-fluid cursor-pointer"
                                            height={36}
                                            width={36}
                                            onClick={() =>
                                              handleModalUpload(bodyObj)
                                            }
                                          />
                                        </div>
                                        <div
                                          data-tip
                                          data-for={`comments${index}`}
                                          // className="uploaded-details-wrapper__icons-wrapper_image"
                                        >
                                          <img
                                            src="/images/uploaded-details/img2.svg"
                                            className="img-fluid cursor-pointer"
                                            height={36}
                                            width={36}
                                            onClick={() =>
                                              handleModalComment(bodyObj)
                                            }
                                          />
                                        </div>
                                        <ReactTooltip id="happyFace1">
                                          <span>Complied</span>
                                        </ReactTooltip>
                                        <ReactTooltip id="happyFace">
                                          <span>Not Applicable</span>
                                        </ReactTooltip>
                                        <ReactTooltip id="happyFace2">
                                          <span>Non Complied</span>
                                        </ReactTooltip>
                                        <ReactTooltip id="happyFace3">
                                          <span>Upload</span>
                                        </ReactTooltip>
                                        <ReactTooltip id={`comments${index}`}>
                                          <span>
                                            {" "}
                                            Comment :{" "}
                                            {getValue(
                                              bodyObj,
                                              `recent_comment.comments`,
                                              "",
                                            )}
                                            ,{" "}
                                          </span>
                                        </ReactTooltip>
                                      </div>
                                      {/* ) : null} */}
                                    </div>
                                  </td>
                                </tr>
                                {getValue(bodyObj, `documents`, []).length >
                                  0 && (
                                  <tr>
                                    <td colSpan={6}>
                                      <div className="table-documents-container">
                                        {getValue(bodyObj, `documents`, []).map(
                                          (documentsObj: object, i: number) => {
                                            return (
                                              <div
                                                className=" table-document d-flex align-items-center"
                                                key={i}
                                              >
                                                <img
                                                  src={`/images/uploaded-details/${
                                                    getValue(
                                                      documentsObj,
                                                      `type`,
                                                      "",
                                                    )
                                                      ? getValue(
                                                          documentsObj,
                                                          `type`,
                                                          "",
                                                        )
                                                      : getValue(
                                                            documentsObj,
                                                            `file_type`,
                                                            "",
                                                          ) === "document"
                                                        ? "pdf"
                                                        : "word"
                                                  }.svg`}
                                                  className="img-fluid cursor-pointer"
                                                />
                                                <p
                                                  className="text"
                                                  onClick={() =>
                                                    handleDownloadOnClick(
                                                      getValue(
                                                        documentsObj,
                                                        `url`,
                                                        "",
                                                      ),
                                                      getValue(
                                                        documentsObj,
                                                        `name`,
                                                        "",
                                                      ),
                                                      getValue(
                                                        documentsObj,
                                                        `key`,
                                                        "",
                                                      ),
                                                    )
                                                  }
                                                >
                                                  {concatDotToDocumentString(
                                                    getValue(
                                                      documentsObj,
                                                      `name`,
                                                      "",
                                                    ),
                                                  )}
                                                </p>
                                              </div>
                                            );
                                          },
                                        )}
                                      </div>
                                      {/* <div className="table-separator"></div> */}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                    </table>
                    {totalCount !== 0 && (
                      <div className="d-flex justify-content-between">
                        {locations.length > 0 && (
                          <img
                            src="/images/profile-illustration.svg"
                            className="img-fluid"
                          />
                        )}
                        {totalCount > 10 ? (
                          <PaginationPage
                            totalCount={totalCount}
                            limit={limit}
                            pageNumber={d_page_no}
                            handleChangePagination={handleChangePagination}
                            handleChangeLimit={handleChangeLimit}
                          />
                        ) : (
                          <p className="show-rows-count mt-3 d-flex">
                            Total Count:&nbsp;&nbsp;{" "}
                            <p style={{ color: "rgb(13, 110, 253)" }}>
                              {totalCount}
                            </p>
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <Notfound />
                  ) : (
                    <Notfound />
                  )}
                </>
              )}
              {isOpen && (
                <CommentsModal
                  {...props}
                  isOpen={isOpen}
                  handleModal={handleModalCommentCancel}
                  vendorInfo={vendorInfo}
                  edit={true}
                  permissions={getValue(props, `permissions`, [])}
                />
              )}
              {isOpen1 && (
                <UploadModal
                  {...props}
                  isOpen={isOpen1}
                  handleModal={handleModalUploadCancel}
                  vendorInfo={vendorInfo}
                  getData={getDataRefetch}
                  permissions={getValue(props, `permissions`, [])}
                />
              )}
              {isOpen2 && (
                <Modal
                  isOpen={isOpen2}
                  toggle={() => handleModal2()}
                  centered
                  className="add-comments-popup"
                >
                  <div className="d-flex justify-content-between add-comments-popup__header">
                    <h3>Add Comments</h3>
                    <img
                      src="/images/close-black.svg"
                      className="img-fluid cursor-pointer"
                      onClick={handleModal2}
                    />
                  </div>
                  <ModalBody>
                    {update_status !== "NOT_APPLICABLE" &&
                      update_status !== "COMPLIED" &&
                      update_status !== "PARTIALLY_COMPLIED" &&
                      update_status !== "SEND_BACK_TO_VENDOR" && (
                        <>
                          <p className="mb-3">Predefined Comments: </p>
                          <div className="grid mb-1">
                            <div className="input-grid-item">
                              <InputField
                                inputType="INPUT_REACT_SELECT_MODAL"
                                placeholder="Select Type"
                                options={commentsTitleList}
                                className="form-control w-100"
                                value={commentsTitleList.filter(
                                  (item: any) =>
                                    getValue(item, `value`, "") ===
                                    selectedCommentLabel,
                                )}
                                onChange={(e: any) =>
                                  handleChangeComments(
                                    "label",
                                    getValue(e, `value`, ""),
                                  )
                                }
                                isClear
                              />
                            </div>
                            <div className="input-grid-item">
                              <InputField
                                inputType="INPUT_REACT_SELECT_MODAL"
                                placeholder="Select Value"
                                className="form-control w-100"
                                options={getValue(
                                  commentsValueList,
                                  `[${selectedCommentLabel}]`,
                                  [],
                                )}
                                value={getValue(
                                  commentsValueList,
                                  `[${selectedCommentLabel}]`,
                                  [],
                                ).filter(
                                  (item: any) =>
                                    getValue(item, `value`, "") ===
                                    selectedCommentValue,
                                )}
                                onChange={(e: any) =>
                                  handleChangeComments(
                                    "value",
                                    getValue(e, `value`, ""),
                                  )
                                }
                                isClear
                              />
                            </div>
                          </div>
                          <br />
                        </>
                      )}
                    <InputField
                      inputType="TEXTAREA"
                      value={comments}
                      onChange={(e: any) => setComments(e.target.value)}
                      placeholder="Add Comment"
                      rows="10"
                      className="add-comments-popup__form-control"
                    />
                    <br />

                    {update_status === "COMPLIED" && (
                      <>
                        <Row>
                          <Col md="6">
                            <Label>Remittance Date</Label>
                            <InputField
                              inputType="DATETYPE-DOB"
                              className="form-control w-100"
                              placeholderText="Enter Remittance Date"
                              value={remittance_date}
                              onChange={(e: any) => setRemittance_date(e)}
                              // minDate={new Date(mainParams.date)}
                            />
                          </Col>
                          {/* <Col md="6">
                            <Label>Expiry Date</Label>
                            <InputField
                              inputType="DATETYPE-DOB"
                              className="form-control"
                              placeholderText="Enter Expiry Date"
                              value={expiry_date}
                              onChange={(e: any) => setExpiry_date(e)}
                              // minDate={new Date()}
                            />
                          </Col> */}
                        </Row>

                        <Row></Row>
                      </>
                    )}

                    <div className="">
                      <div className="">
                        <Label>Recommendation</Label>
                        <InputField
                          inputType="TEXT"
                          value={recommendation}
                          onChange={(e: any) =>
                            setRecommendation(sanitizeInput(e.target.value))
                          }
                          placeholder="Add Recommendation"
                          className="add-comments-popup__form-control"
                          label={"Recommendation"}
                        />
                      </div>
                    </div>

                    {(update_status === "NOT_APPLICABLE" ||
                      update_status === "COMPLIED" ||
                      update_status === "PARTIALLY_COMPLIED") && (
                      <>
                        <div className="position-relative mt-3">
                          <div
                            className="custom-switch-wrapper-blue custom-switch-wrapper-icons"
                            style={{ marginTop: "5px", marginBottom: "15px" }}
                          >
                            Carry Forward Task
                            <label className="switch ms-3">
                              <input
                                type="checkbox"
                                checked={carryForwardTask}
                                onChange={() =>
                                  setCarryForwardTask(!carryForwardTask)
                                }
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>

                        {carryForwardTask && (
                          <>
                            <div className="d-flex align-items-center">
                              <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center me-2">
                                <input
                                  type="radio"
                                  checked={lifeTimeCarryForward === true}
                                  onChange={() => setLifeTimeCarryForward(true)}
                                />
                                <label className="ms-1">Life Time</label>
                              </div>
                              <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center me-2">
                                <input
                                  type="radio"
                                  checked={lifeTimeCarryForward === false}
                                  onChange={() =>
                                    setLifeTimeCarryForward(false)
                                  }
                                />
                                <label className="ms-1">Expires on</label>
                              </div>
                            </div>

                            <div className="mt-1">
                              {/* Conditionally render the textbox when No (false) is selected */}
                              {!lifeTimeCarryForward && (
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="form-control"
                                  placeholderText="Enter Expiry Date"
                                  value={cc_expiry_date}
                                  onChange={(e: any) => setCC_Expiry_date(e)}
                                  minDate={new Date()}
                                />
                              )}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </ModalBody>
                  <div className="d-flex justify-content-end add-comments-popup__footer">
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                      onClick={() => handleModal2()}
                    >
                      Close
                    </button>
                    {submitLoading ? (
                      <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                        Please wait...
                      </button>
                    ) : (
                      <button
                        className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                        onClick={handleSubmitTask}
                        disabled={
                          !getValue(props, `permissions`, []).includes("update")
                        }
                      >
                        Submit
                      </button>
                    )}
                  </div>
                  {/* <div className="footer-wrapper d-flex justify-content-between mt-4">
                    <img
                      src="/images/building-illustration.svg"
                      className="img-fluid"
                    />
                  </div> */}
                </Modal>
              )}
              {isOpen3 && (
                <Modal
                  isOpen={isOpen3}
                  toggle={() => handleModal3()}
                  centered
                  className="add-comments-popup"
                >
                  <div className="d-flex justify-content-between add-comments-popup__header">
                    <h3>Update Remittance And Expiry Date</h3>
                    <img
                      src="/images/close-black.svg"
                      className="img-fluid cursor-pointer"
                      onClick={handleModal3}
                    />
                  </div>
                  <ModalBody>
                    <>
                      <Label>Remittance Date</Label>
                      <InputField
                        inputType="DATETYPE-DOB"
                        className="form-control w-100"
                        placeholderText="Enter Remittance Date"
                        value={getValue(request, `remittance_date`, "")}
                        onChange={(e: any) =>
                          setRequest({ ...request, remittance_date: e })
                        }

                        // minDate={new Date(mainParams.date)}
                      />

                      <Label>Expiry Date</Label>
                      <InputField
                        inputType="DATETYPE-DOB"
                        className="form-control"
                        placeholderText="Enter Expiry Date"
                        value={getValue(request, `expiry_date`, "")}
                        onChange={(e: any) =>
                          setRequest({ ...request, expiry_date: e })
                        }
                        // minDate={new Date()}
                      />
                    </>
                  </ModalBody>
                  <div className="d-flex justify-content-end add-comments-popup__footer">
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                      onClick={() => handleModal3()}
                    >
                      Close
                    </button>

                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                      onClick={handleSubmit}
                      // disabled={submitRequestLoading}
                      disabled={
                        submitRequestLoading ||
                        !getValue(props, `permissions`, []).includes("update")
                      }
                    >
                      {submitRequestLoading ? "Please wait..." : "Submit"}
                    </button>
                  </div>
                  <div className="footer-wrapper d-flex justify-content-between mt-4">
                    <img
                      src="/images/building-illustration.svg"
                      className="img-fluid"
                    />
                  </div>
                </Modal>
              )}
              {isOpen4 && (
                <Modal
                  isOpen={isOpen4}
                  toggle={() => handleModal4()}
                  centered
                  className="add-comments-popup"
                >
                  <div className="d-flex justify-content-between add-comments-popup__header">
                    <h3>Add Comments</h3>
                    <img
                      src="/images/close-black.svg"
                      className="img-fluid cursor-pointer"
                      onClick={handleModal4}
                    />
                  </div>
                  <ModalBody>
                    {/* <Row> */}
                    <Col md="12" className="mb-2 d-none">
                      <p className="mb-3">Predefined Comments* : </p>
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Select Type"
                        options={commentsTitleList}
                        value={commentsTitleList.filter(
                          (item: any) =>
                            getValue(item, `value`, "") ===
                            selectedCommentLabel,
                        )}
                        onChange={(e: any) =>
                          handleChangeComments1(
                            "label",
                            getValue(e, `value`, ""),
                          )
                        }
                        isClear
                      />
                    </Col>
                    <Col md="12" className="d-none">
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Select Value"
                        options={getValue(
                          commentsValueList,
                          `[${selectedCommentLabel}]`,
                          [],
                        )}
                        value={getValue(
                          commentsValueList,
                          `[${selectedCommentLabel}]`,
                          [],
                        ).filter(
                          (item: any) =>
                            getValue(item, `value`, "") ===
                            selectedCommentValue,
                        )}
                        onChange={(e: any) =>
                          handleChangeComments1(
                            "value",
                            getValue(e, `value`, ""),
                          )
                        }
                        isClear
                      />
                    </Col>
                    {/* </Row> */}
                    <br />

                    <label>Audit Status *</label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      options={filterOptions}
                      value={filterOptions.filter(
                        (item: any) => item.value == updateValue,
                      )}
                      className="add-comments-popup__form-control"
                      onChange={(e: any) => setUpdateValue(e.value)}
                      placeholder={"Select Status"}
                    />

                    <br />
                    <p className="mb-3">Comments* : </p>
                    <InputField
                      inputType="TEXTAREA"
                      value={comments1}
                      onChange={(e: any) =>
                        setComments1(sanitizeInput(e.target.value))
                      }
                      placeholder="Add Comment"
                      // rows="10"
                      className="add-comments-popup__form-control"
                    />
                  </ModalBody>
                  <div className="d-flex justify-content-end add-comments-popup__footer">
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                      onClick={() => handleModal4()}
                    >
                      Close
                    </button>
                    {
                      <button
                        className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                        onClick={handleChangeUpdate}
                        disabled={
                          submitLoading ||
                          !getValue(props, `permissions`, []).includes("update")
                        }
                      >
                        {submitLoading ? "Please wait..." : "Submit"}
                      </button>
                    }
                  </div>
                  <div className="footer-wrapper d-flex justify-content-between mt-4">
                    <img
                      src="/images/building-illustration.svg"
                      className="img-fluid"
                    />
                  </div>
                </Modal>
              )}
            </section>
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
